import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { FormService } from '../Services/form.service';
import { BusinessOperatorService } from '../Services/business-operator.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../Services/auth.service';
import { Logininfo } from '../classes/Loginifo';

@Component({
  selector: 'app-business-operator',
  templateUrl: './business-operator.component.html',
  styleUrls: ['./business-operator.component.css']
})
export class BusinessOperatorComponent implements OnInit {
  logininfo: Logininfo = this.auth.loginID;
  list;
  closeResult: string;

  BusinessForm = new FormGroup({
    name: new FormControl(''),
    short_name: new FormControl(''),
    type: new FormControl(1),
    zip_code: new FormControl(''),
    pref: new FormControl(''),
    city: new FormControl(''),
    address: new FormControl(''),
    tel: new FormControl(''),
    fax: new FormControl(''),
    mail: new FormControl(''),
  });

  constructor(
    private formService: FormService,
    private bos: BusinessOperatorService,
    private modalService: NgbModal,
    public auth: AuthService
  ) {
    this.bos.getBusiness(1).subscribe(res => {
      this.list = res;
    });
  }

  ngOnInit() {
  }

  submit() {
    this.bos.insertBusiness(this.BusinessForm.value);
  }

  edit(content, index) {
    this.BusinessForm.controls.name.setValue(this.list[index].business_name);
    this.BusinessForm.controls.short_name.setValue(this.list[index].business_short_name);
    this.BusinessForm.controls.zip_code.setValue(this.list[index].zip_code);
    this.BusinessForm.controls.pref.setValue(this.list[index].pref);
    this.BusinessForm.controls.city.setValue(this.list[index].city);
    this.BusinessForm.controls.address.setValue(this.list[index].address);
    this.BusinessForm.controls.tel.setValue(this.list[index].tel_number);
    this.BusinessForm.controls.fax.setValue(this.list[index].fax_number);
    this.BusinessForm.controls.mail.setValue(this.list[index].mail_address);

    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  /**
   * 郵便番号から住所を取得
   * @param zip 
   */
  searchZip(zip: string) {
    if (zip.length == 7) {
      this.formService.searchZip(zip).then(addr => {
        this.setZip(addr);
      });
    }
  }

  /**
   * 取得した住所をフォームにセット
   * @param addr 
   */
  setZip(addr) {
    if (addr !== undefined) {
      this.BusinessForm.controls.pref.setValue(this.formService.Prefectures[addr[0]]);
      this.BusinessForm.controls.city.setValue(addr[1]);
      this.BusinessForm.controls.address.setValue(addr[2]);
    }
  }
}
